function pushEvent(eventName, params = {}) {
    if (typeof window !== "undefined" && window.dataLayer) {
        window.dataLayer.push({
            event: eventName,
            ...params,
        });
    }
}

export function trackDiagnosticStarted(mode = "self_serve") {
    pushEvent("diagnostic_started", { mode });
}

export function trackStepViewed(stepNumber, stepName, mode = "self_serve") {
    pushEvent("diagnostic_step_viewed", {
        step_number: stepNumber,
        step_name: stepName,
        mode,
    });
}

export function trackStepCompleted(
    stepNumber,
    stepName,
    timeOnStepSeconds,
    mode = "self_serve",
) {
    pushEvent("diagnostic_step_completed", {
        step_number: stepNumber,
        step_name: stepName,
        time_on_step_seconds: timeOnStepSeconds,
        mode,
    });
}

export function trackBackClicked(fromStep, toStep, mode = "self_serve") {
    pushEvent("diagnostic_back_clicked", {
        from_step: fromStep,
        to_step: toStep,
        mode,
    });
}

export function trackDiagnosticCompleted(
    completionTimeSeconds,
    mode = "self_serve",
) {
    pushEvent("diagnostic_completed", {
        completion_time_seconds: completionTimeSeconds,
        mode,
    });
}

export function trackResultViewed(
    recommendation,
    composite,
    mode = "self_serve",
) {
    pushEvent("diagnostic_result_viewed", {
        recommended_package: recommendation,
        grunnstada: composite.grunnstada,
        thrystingur: composite.thrystingur,
        taekifaeri: composite.taekifaeri,
        mode,
    });
}

export function trackPackageRecommended(recommendation, composite) {
    pushEvent("diagnostic_package_recommended", {
        recommended_package: recommendation,
        grunnstada: composite.grunnstada,
        thrystingur: composite.thrystingur,
        taekifaeri: composite.taekifaeri,
    });
}

export function trackCTAClicked(ctaType, recommendation, mode = "self_serve") {
    pushEvent("diagnostic_cta_clicked", {
        cta_type: ctaType,
        recommended_package: recommendation,
        mode,
    });
}

export function trackLeadSubmitted(leadCaptureVariant, mode, recommendation) {
    pushEvent("diagnostic_lead_submitted", {
        lead_capture_variant: leadCaptureVariant,
        mode,
        recommended_package: recommendation,
    });
}

export function trackCRMSubmitSuccess(recommendation) {
    pushEvent("diagnostic_crm_submit_success", {
        recommended_package: recommendation,
    });
}

export function trackCRMSubmitFailed(errorCode, recommendation) {
    pushEvent("diagnostic_crm_submit_failed", {
        error_code: errorCode,
        recommended_package: recommendation,
    });
}

export function trackDiagnosticAbandoned(
    lastStepCompleted,
    mode,
    timeOnPageSeconds,
) {
    pushEvent("diagnostic_abandoned", {
        last_step_completed: lastStepCompleted,
        mode,
        time_on_page_seconds: timeOnPageSeconds,
    });
}
